export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4031886182801b68f2131070d62bf79ff73af97440&name=revalidateCommunity!'